export const arrayToQueryParam = (
  array: string[],
  queryString: string
): string => {
  return array.reduce((acc, item, index) => {
    return `${acc}${index !== 0 ? '&' : ''}${queryString}=${item}`;
  }, '');
};
